export function setSessionData(key, value) {
    if (isSessionStorageSupported()) {
        sessionStorage.setItem(key, value);
    }
}

export function getSessionData(key) {
    if (isSessionStorageSupported()) {
        return sessionStorage.getItem(key);
    }

    return null;
}
export function removeSessionData(key) {
    if (isSessionStorageSupported()) {
        sessionStorage.removeItem(key);
    }
}

export function sessionDataExists(key) {
    if (isSessionStorageSupported()) {
        return sessionStorage.getItem(key) !== null;
    }

    return false;
}

export function isSessionStorageSupported() {
    const isSessionStorageSupported =
        typeof (Storage) !== undefined && window.sessionStorage != undefined;

    if (!isSessionStorageSupported) {
        console.log("Session storage is not supported.");
        return false;
    }

    return true;
}

export default {
    methods: {
        setSessionData,
        getSessionData,
        removeSessionData,
        sessionDataExists,
        isSessionStorageSupported
    }
}